export default "__VITE_PUBLIC_ASSET__cda1f024__"